import { render, staticRenderFns } from "./DeviceDetailDrawer.vue?vue&type=template&id=810f5228&scoped=true"
import script from "./DeviceDetailDrawer.vue?vue&type=script&lang=js"
export * from "./DeviceDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./DeviceDetailDrawer.vue?vue&type=style&index=0&id=810f5228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810f5228",
  null
  
)

export default component.exports